const resources = {
  en: {
    "translation": {
      "delegate": "Delegate",
      "chilli": "Chilli",
      "other": "Others",
      "language": "english",
      "pleasescan": "Please scan the QR code to procced",
      "profileText": "Your profile is being registered in the Corteva Farmer Connect app and you authorize Corteva to contact you for future marketing activities.",
      "loginLabel": "Mobile Number",
      "loginPlaceHolder": "Mobile No.",
      "mobileErrorMsg": "Please enter mobile number",
      "submitBtn": "Submit",
      "loginBtn": "Login",
      "otpText": "OTP will be sent as an SMS to {mobileNumber}",
      "otpError": "Please enter a valid OTP",
      "OTPLabel": "OTP",
      "firstName": "First Name",
      "firstNameErrorMsg": "Please enter first name",
      "lastName": "Last Name",
      "lastNameErrorMsg": "Please enter last name",
      "pincode": "Pincode",
      "address": "Address",
      "done": "Done",
      "submit": "Submit",
      "scanTitle": "Scan the QR code given on the bottle",
      "scanning": "Scanning",
      "scan": "Scan",
      "rescan": "Rescan",
      "scanSteps": "Steps to scan the QR code",
      "stepOne": "Step 1: Find the QR code on the pouch",
      "stepTwo": "Step 2: Scan the QR code and submit",
      "spinToWin": "Click to win prize",
      "nextStep": "अगले चरण पर जाएं",
      "scanProduct": "Scan Product",
      "proceedToContinue": "Proceed to Continue",
      "SpinWheel": "Spin the wheel to win prizes",
      "congratulations": "Congratulations",
      "giftcongratulations": "Congratulations, you are a winner!",
      "earned": "You have earned Rs. 20.00 cash for Delegate",
      "redeemCash": "Get Cash Payment",
      "ClaimReward": "Claim Reward",
      "updatesOnReward": "You are a winner with Delegate. Contact your local Corteva representative for updates on the reward",
      "paymentMode": "Select Payment Mode",
      "bankDetails": "Bank Details",
      "accountHolderName": "Account Holder Name",
      "accountHolderNameErrorMsg": "Account holder name is required",
      "accountNumber": "Account Number",
      "accountNumberErrorMsg": "Please enter account number",
      "IFSCCode": "IFSC Code",
      "IFSCCodeErrorMsg": "Please enter IFSC code",
      "confirm": "Confirm",
      "UPIErrorMsg": "UPI required",
      "transferSuccessText": "Your cash transfer <br> is successful",
      "successSubtitile": "We have sent your money!",
      "goHome": "Go to Home Page",
      "delegateRewards": "Delegate Rewards",
      "claimList": "Claim List",
      "noClaimsFound": "No claims found",
      "noSuccessList": "No success list found",
      "reclaimList": "Reclaim List",
      "noReclaimList": "No reclaim list found",
      "termsAndConditions": "Delegate Blast - Terms and Conditions",
      "privacyPolicy": "Privacy Policy",
      "agreeText": "By submitting, you agree to our terms",
      "genuityCheck": "Product Authenticity Check",
      "resendOTP": "Resend OTP",
      "invalidOTP": "Invalid OTP",
      "productName": "Product",
      "serialNO": "Serial No.",
      "alreadyLoginText": "Your number is also logged in to the Farmer Connect app. Press OK to log in.",
      "notRegisteredText": "Your number is not registered. Please register to participate in Delegate Blast.",
      "loginConfirm": "Login Confirmation",
      "Alert": "Alert!",
      "no": "No",
      "yes": "Yes",
      "OK": "OK",
      "amount": "Amount",
      "Date": "Date",
      "claim": "Claim",
      "successList": "Success List",
      "referenceId": "Reference ID",
      "status": "Status",
      "Scanmore": "Scan More",
      "Rewards": "Rewards",
      "reward": "Reward",
      "transfer": "Transfer",
      "home": "Home",
      "TC": "T&C",
      "ProductInfo": "Product <br> Information",
      "downloadBrochure": "Download Brochure <br> ",
      "programDetails": "Program Details",
      "delegateParticipate": "Delegate Friendship Blast - Participate",
      "termsAndConditions": "Delegate Blast - Terms and Conditions",
      "award": "Award",
      "TermsandConditons": "Terms and Conditions",
      "and": "and",
      "privacyPolicy": "Privacy Policy",
      "BackToHome": "Back to Home Page",
      "ReferenceId": "Reference ID",
      "noData": "No data available",
      "mblnumberPlaceHolder": "Retailer's Mobile Number",
      "name": "Name",
      "cottn": "Cotton",
      "corn": "Corn",
      "enterOTP": "Enter OTP",
      "login": "Login",
      "scanagain": "Scan Again",
      "cropErrorMsg": "Please select a crop",
      "nameErrorMsg": "Please enter your name",
      "Reclaim": "Reclaim",
      "Skip": "Skip",
      "Claim": "Claim",
      "StepsImage": "Delegate Double Blast - How to Participate",
      "UPI": "UPI",
      "bankDetails": "Bank Details",
      "confirmaccountNumber": "Confirm Account Number",
      "confirmaccountNumberErrorMsg": "Please enter Confirm Account Number",
      "confirmAccountNumberMismatch": 'The account number confirmation account number does not match',
      "TermsandConditons": "Terms and Conditions",
      "accept": "Accept",
      "decline": "Decline",
      "UPILinkedMobileNumber": "UPI Linked Mobile Number",
      "close": "Close",
      "modify": "Modify"

    }
  },
  hi: {
    translation: {
      delegate: "डेलीगेट",
      "chilli": "मिर्च",
      "language": "hindi",
      "other": "अन्य",
      "pleasescan": "कृपया प्रॉक्सी से सीआर कोड को स्कैन करें",
      "profileText": "*आपकी प्रोफ़ाइल 'Corteva Farmer Connect' ऐप में पंजीकृत की जा रही है और आप भविष्य की विपणन गतिविधियों के लिए कोर्टेवा को आपसे संपर्क करने के लिए अधिकृत करते हैं।",
      loginLabel: "मोबाइल नंबर",
      loginPlaceHolder: "मोबाइल नं.",
      mobileErrorMsg: "कृपया मोबाइल नंबर दर्ज करें",
      submitBtn: "जमा करें",
      loginBtn: "लॉगिन",
      otpText: "ओटीपी {mobileNumber} पर एसएमएस के रूप में भेजा जाएगा",
      otpError: "कृपया मान्य OTP दर्ज करें",
      OTPLabel: "ओटीपी",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "हो गया",
      submit: "उपस्थित करना",
      scanTitle: "बोतल पर दिया क्यूआर कोड स्कैन करें",
      scanning: "स्कैनिंग",
      scan: "स्कैन करें",
      rescan: "दोबारा स्कैन करें",
      scanSteps: "क्यूआर कोड को स्कैन करने के चरण",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      spinToWin: "इनाम जीतने के लिए क्लिक करें",
      "nextStep": "अगले चरण पर जाएं",
      scanProduct: "उत्पाद स्कैन करें",
      proceedToContinue: "आगे बढ़ने के लिए जारी रखें",
      SpinWheel: "पुरस्कार पाने के लिए व्हील को घुमाएँ",
      congratulations: "बधाई हो",
      giftcongratulations: "बधाई हो, आप विजेता हैं।​",
      earned: "आपने रु. कमाए हैं. डेलीगेट के लिए 20.00 नकद",
      redeemCash: "नकद भुगतान पायें",
      ClaimReward: "इनाम का दावा करें",
      updatesOnReward: "आप डेलीगेट के साथ विजेता हैं। अपने स्थानीय कॉर्टेवा प्रतिनिधि से संपर्क करें इनाम पर अपडेट के लिए",
      paymentMode: "भुगतान मोड चुनें​",
      bankDetails: "बैंक विवरण",
      accountHolderName: "खाते का नाम​",
      accountHolderNameErrorMsg: "खाते का नाम आवश्यक है",
      accountNumber: "खाता संख्या​",
      accountNumberErrorMsg: "कृपया खाता संख्या दर्ज करें",
      IFSCCode: "IFSC कोड",
      IFSCCodeErrorMsg: "कृपया IFSC कोड दर्ज करें",
      confirm: "पुष्टि करें",
      UPIErrorMsg: "यूपीआई आवश्यक",
      transferSuccessText: "आपका नकद ट्रांसफर <br> सफल है​",
      successSubtitile: "हमने आपको आपका पैसा भेज दिया है!",
      goHome: "होम पेज पर जाएँ",
      delegateRewards: "डेलीगेट पुरस्कार",
      claimList: "दावा सूची",
      noClaimsFound: "कोई दावा नहीं मिला",
      noSuccessList: "कोई सफलता सूची नहीं मिली",
      reclaimList: "दुबारा दावा सूची",
      noReclaimList: "कोई पुनः दावा सूची नहीं मिली",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      privacyPolicy: "गोपनीयता नीति",
      agreeText: "सबमिट करके आप हमारे साथ सहमत होते हैं",
      genuityCheck: "उत्पाद की प्रामाणिकता जाँच​",
      resendOTP: "OTP पुन: भेजें",
      productName: "उत्पाद",
      serialNO: "क्र. संख्या",
      alreadyLoginText:
        "आपका नंबर भी फार्मर कनेक्ट ऐप में लॉग इन है. लॉग इन करने के लिए ओके दबाएं।​",
      notRegisteredText:
        "आपका नंबर पंजीकृत नहीं है. कृपया डेलीगेट धमाका में भाग लेने के लिए पंजीकरण करें।​",
      loginConfirm: "लॉगिन पुष्टिकरण",
      Alert: "चेतावनी!",
      no: "नहीं",
      yes: "हाँ",
      OK: "ठीक है",
      amount: "रुपये",
      Date: "तिथि",
      claim: "दावा",
      successList: "सफलता सूची",
      referenceId: "संन्दर्भ आईडी",
      status: "स्थिति",
      Scanmore: "और भी स्कैन करें​",
      Rewards: "पुरस्कार",
      reward: "पुरस्कार",
      transfer: "ट्रांसफर",
      home: "होम",
      TC: "T&C",
      ProductInfo: "उत्पाद की <br>जानकारी",
      downloadBrochure: "ब्रोशर डाउनलोड <br> करें",
      programDetails: "कार्यक्रम विवरण",
      delegateParticipate: " डेलीगेट दोस्ती धमाका - भाग लें",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      award: "पुरस्कार",
      TermsandConditons: "नियम और शर्तें",
      and: "आणि",
      privacyPolicy: "गोपनीयता धोरण",
      BackToHome: "होम पेज पर जायें",
      ReferenceId: "संदर्भ पहचान पत्र",
      noData: "कोई डेटा मौजूद नहीं",
      mblnumberPlaceHolder: 'खुदरा विक्रेता का मोबाइल नंबर',
      name: "नाम",
      cottn: "कपास",
      corn: "मक्का",
      enterOTP: "OTP दर्ज करें",
      login: "लॉगिन करें​",
      scanagain: "दोबारा स्कैन करें",
      cropErrorMsg: "कृपया फसल चुनें​",
      nameErrorMsg: "कृपया अपना नाम दर्ज करें",
      Reclaim: "दुबारा दावा",
      Skip: "Skip",
      Claim: "दावा",
      StepsImage: "डेलीगेट डबल धमाका - ऐसे भाग लें",
      UPI: "यूपीआई",
      bankDetails: "बैंक विवरण",
      sessionExperied: "सत्र समाप्त हुआ। कृपया QR कोड स्कैन करें",
      "confirmaccountNumber": "खाता संख्या की पुष्टि करें",
      "confirmaccountNumberErrorMsg": "कृपया पुष्टि खाता संख्या दर्ज करें",
      "confirmAccountNumberMismatch": 'खाता संख्या पुष्टिकरण खाता संख्या मेल नहीं खाती',
      "invalidOTP": "अमान्य ओटीपी",
      "TermsandConditons": "नियम और शर्तें",
      "accept": "स्वीकार करें",
      "decline": "अस्वीकार करें",
      "UPILinkedMobileNumber": "यूपीआई से जुड़ा मोबाइल नंबर",
      "close": "बंद करें",
      "modify": "बदलें"
    },
  },
  bn: {
    translation: {
      delegate: "ডেলিগেট",
      "chilli": "লঙ্কা",
      "language": "bengali",
      "other": "অন্যান্য",
      "pleasescan": "कृपया प्रॉक्सी से सीआर कोड को स्कैन करें",
      "profileText": "*আপনার প্রোফাইল Corteva Farmer Connect অ্যাপে নিবন্ধিত হচ্ছে এবং ভবিষ্যতে বিপণনমূলক কার্যক্রমের জন্য Corteva-কে আপনার সাথে যোগাযোগ করার অনুমতি দিচ্ছেন।",
      loginLabel: "মোবাইল নম্বর",
      loginPlaceHolder: "মোবাইল নং",
      mobileErrorMsg: "অনুগ্রহ করে মোবাইল নম্বর লিখুন",
      submitBtn: "জমা দিন",
      loginBtn: "লগইন",
      otpText: "{mobileNumber} নম্বরে SMS-এর মাধ্যমে OTP পাঠানো হবে",
      otpError: "অনুগ্রহ করে সঠিক OTP লিখুন",
      OTPLabel: "ওটিপি",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "সম্পন্ন",
      submit: "জমা দিন",
      scanTitle: "বোতলে দেওয়া QR কোড স্ক্যান করুন",
      scanning: "স্ক্যান হচ্ছে",
      scan: "স্ক্যান করুন",
      rescan: "পুনরায় স্ক্যান করুন",
      scanSteps: "क्यूआर कोड को स्कैन करने के चरण",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      spinToWin: "পুরস্কার জিততে ক্লিক করুন",
      "nextStep": "পরবর্তী ধাপে যান",
      scanProduct: "পণ্য স্ক্যান করুন",
      proceedToContinue: "এগিয়ে যেতে চালিয়ে যান",
      SpinWheel: "পুরস্কার জিততে চাকা ঘোরান",
      congratulations: "অভিনন্দন",
      giftcongratulations: "অভিনন্দন, আপনি বিজয়ী!​",
      earned: "আপনি Delegate-এর জন্য ₹20.00 নগদ পেয়েছেন",
      redeemCash: "নগদ অর্থ গ্রহণ করুন",
      ClaimReward: "পুরস্কার দাবি করুন",
      updatesOnReward: "আপনি Delegate-এর বিজয়ী। পুরস্কারের আপডেটের জন্য আপনার স্থানীয় Corteva প্রতিনিধির সাথে যোগাযোগ করুন।",
      paymentMode: "অর্থপ্রদানের পদ্ধতি নির্বাচন করুন​",
      bankDetails: "ব্যাংকের বিবরণ",
      accountHolderName: "অ্যাকাউন্টধারীর নাম​",
      accountHolderNameErrorMsg: "অ্যাকাউন্টধারীর নাম আবশ্যক",
      accountNumber: "অ্যাকাউন্ট নম্বর​",
      accountNumberErrorMsg: "অনুগ্রহ করে অ্যাকাউন্ট নম্বর লিখুন",
      IFSCCode: "IFSC কোড",
      IFSCCodeErrorMsg: "অনুগ্রহ করে IFSC কোড লিখুন",
      confirm: "নিশ্চিত করুন",
      UPIErrorMsg: "UPI প্রয়োজন",
      transferSuccessText: "আপনার নগদ স্থানান্তর <br> সফল হয়েছে",
      successSubtitile: "আপনার টাকা পাঠানো হয়েছে!",
      goHome: "হোম পেজে যান",
      delegateRewards: "ডেলিগেট পুরস্কার",
      claimList: "দাবি তালিকা",
      noClaimsFound: "কোনো দাবি পাওয়া যায়নি",
      noSuccessList: "কোনো সফলতার তালিকা পাওয়া যায়নি",
      reclaimList: "পুনরায় দাবি তালিকা",
      noReclaimList: "কোনো পুনরায় দাবি তালিকা পাওয়া যায়নি",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      privacyPolicy: "গোপনীয়তা নীতি",
      agreeText: "জমা দেওয়ার মাধ্যমে আপনি আমাদের শর্তাবলীতে সম্মত হচ্ছেন",
      genuityCheck: "পণ্যের সত্যতা যাচাই",
      resendOTP: "আবার OTP পাঠান",
      productName: "পণ্য",
      serialNO: "সিরিয়াল নং",
      alreadyLoginText:
        "आपका नंबर भी फार्मर कनेक्ट ऐप में लॉग इन है. लॉग इन करने के लिए ओके दबाएं।​",
      notRegisteredText:
        "आपका नंबर पंजीकृत नहीं है. कृपया डेलीगेट धमाका में भाग लेने के लिए पंजीकरण करें।​",
      loginConfirm: "लॉगिन पुष्टिकरण",
      Alert: "সতর্কবার্তা!",
      no: "নহী",
      yes: "হাঁ",
      OK: "ঠিক আছে",
      amount: "পরিমাণ",
      Date: "তারিখ",
      claim: "দাবি করুন",
      successList: "সফলতার তালিকা",
      referenceId: "রেফারেন্স আইডি",
      status: "অবস্থা",
      Scanmore: "আরও স্ক্যান করুন​",
      Rewards: "পুরস্কার",
      reward: "পুরস্কার",
      transfer: "স্থানান্তর",
      home: "হোম",
      TC: "T&C",
      ProductInfo: "उत्पाद की <br>जानकारी",
      downloadBrochure: "ब्रोशर डाउनलोड <br> करें",
      programDetails: "कार्यक्रम विवरण",
      delegateParticipate: " डेलीगेट दोस्ती धमाका - भाग लें",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      award: "পুরস্কার",
      TermsandConditons: "নিয়ম ও শর্তাবলী",
      and: "आणि",
      privacyPolicy: "গোপনীয়তা নীতি",
      BackToHome: "হোম পেজে ফিরে যান",
      ReferenceId: "রেফারেন্স আইডি",
      noData: "কোই ডেটা মৌজুদ নহি",
      mblnumberPlaceHolder: 'খুদরা বিক্রেতা কা মোবাইল নং',
      name: "নাম",
      cottn: "তুলা",
      corn: "ভুট্টা",
      enterOTP: "OTP লিখুন",
      login: "লগইন​",
      scanagain: "আবার স্ক্যান করুন",
      cropErrorMsg: "অনুগ্রহ করে একটি ফসল নির্বাচন করুন​",
      nameErrorMsg: "অনুগ্রহ করে আপনার নাম লিখুন",
      Reclaim: "পুনরায় দাবি করুন",
      Skip: "এড়িয়ে যান",
      Claim: "দাবি করুন",
      StepsImage: "ডেলীগেট ডবল ধমাকা - ঐসে ভাগ লাগেন",
      UPI: "UPI",
      bankDetails: "ব্যাংকের বিবরণ",
      sessionExperied: "সত্র সমাপ্ত হয়েছে। কৃপয় QR কোড স্ক্যান করুন",
      "confirmaccountNumber": "অ্যাকাউন্ট নম্বর নিশ্চিত করুন",
      "confirmaccountNumberErrorMsg": "অনুগ্রহ করে নিশ্চিতকরণ অ্যাকাউন্ট নম্বর লিখুন",
      "confirmAccountNumberMismatch": 'অ্যাকাউন্ট নম্বর ও নিশ্চিতকরণ অ্যাকাউন্ট নম্বর মেলেনি',
      "invalidOTP": "ভুল OTP",
      "TermsandConditons": "নিয়ম ও শর্তাবলী",
      "accept": "গ্রহণ করুন",
      "decline": "প্রত্যাখ্যান করুন",
      "UPILinkedMobileNumber": "UPI-সংযুক্ত মোবাইল নম্বর",
      "close": "বন্ধ করুন",
      "modify": "পরিবর্তন করুন"
    },
  },
  or: {
    translation: {
      delegate: "ଡେଲିଗେଟ୍",
      "chilli": "ଲଙ୍କା",
      "language": "oriya",
      "other": "ଅନ୍ୟାନ୍ୟ",
      "pleasescan": "कृपया प्रॉक्सी से सीआर कोड को स्कैन करें",
      "profileText": "*ଆପଣଙ୍କର ପ୍ରୋଫାଇଲ Corteva Farmer Connect ଆପ୍‌ରେ ପଞ୍ଜିକୃତ ହେଉଛି ଏବଂ ଭବିଷ୍ୟତର ବିପଣନ କାର୍ଯ୍ୟକଳାପ ପାଇଁ Corteva ଆପଣଙ୍କ ସହ ଯୋଗାଯୋଗ କରିପାରିବ ବୋଲି ଆପଣ ଅନୁମତି ଦେଉଛନ୍ତି।",
      loginLabel: "ମୋବାଇଲ ନମ୍ବର",
      loginPlaceHolder: "ମୋବାଇଲ ନଂ",
      mobileErrorMsg: "ଦୟାକରି ମୋବାଇଲ ନମ୍ବର ଲେଖନ୍ତୁ",
      submitBtn: "ଦାଖଲ କରନ୍ତୁ",
      loginBtn: "ଲଗଇନ୍",
      otpText: "{mobileNumber} ନମ୍ବରକୁ SMS ମାଧ୍ୟମରେ OTP ପଠାଯିବ",
      otpError: "ଦୟାକରି ବୈଧ OTP ଲେଖନ୍ତୁ",
      OTPLabel: "OTP",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "ସମ୍ପୂର୍ଣ୍ଣ",
      submit: "ଦାଖଲ କରନ୍ତୁ",
      scanTitle: "ବୋତଲରେ ଦିଆଯାଇଥିବା QR କୋଡ୍ ସ୍କାନ୍ କରନ୍ତୁ",
      scanning: "ସ୍କାନ୍ ହେଉଛି",
      scan: "ସ୍କାନ୍ କରନ୍ତୁ",
      rescan: "ପୁଣିଥରେ ସ୍କାନ୍ କରନ୍ତୁ",
      scanSteps: "क्यूआर कोड को स्कैन करने के चरण",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      spinToWin: "ପୁରସ୍କାର ଜିତିବା ପାଇଁ କ୍ଲିକ୍ କରନ୍ତୁ",
      "nextStep": "ପରବର୍ତ୍ତୀ ପଦକ୍ଷେପକୁ ଯାଆନ୍ତୁ",
      scanProduct: "ଉତ୍ପାଦ ସ୍କାନ୍ କରନ୍ତୁ",
      proceedToContinue: "ଆଗକୁ ବଢ଼ିବାକୁ ଜାରି ରଖନ୍ତୁ",
      SpinWheel: "ପୁରସ୍କାର ଜିତିବା ପାଇଁ ଚକ୍ର ଘୁରାନ୍ତୁ",
      congratulations: "ଅଭିନନ୍ଦନ",
      giftcongratulations: "ଅଭିନନ୍ଦନ, ଆପଣ ବିଜେତା!​",
      earned: "ଆପଣ Delegate ପାଇଁ ₹20.00 ନଗଦ ଜିତିଛନ୍ତି",
      redeemCash: "ନଗଦ ଅର୍ଥ ପାଆନ୍ତୁ",
      ClaimReward: "ପୁରସ୍କାର ଦାବି କରନ୍ତୁ",
      updatesOnReward: "ଆପଣ Delegate ସହିତ ବିଜେତା ହୋଇଛନ୍ତି। ପୁରସ୍କାର ସମ୍ବନ୍ଧୀୟ ଅଦ୍ୟତନ ପାଇଁ ଆପଣଙ୍କ ସ୍ଥାନୀୟ Corteva ପ୍ରତିନିଧିଙ୍କୁ ଯୋଗାଯୋଗ କରନ୍ତୁ।",
      paymentMode: "ଅର୍ଥ ପ୍ରଦାନ ପ୍ରକ୍ରିୟା ବାଛନ୍ତୁ​",
      bankDetails: "ବ୍ୟାଙ୍କ ବିବରଣୀ",
      accountHolderName: "ଖାତାଧାରୀଙ୍କ ନାମ​",
      accountHolderNameErrorMsg: "ଖାତାଧାରୀଙ୍କ ନାମ ଆବଶ୍ୟକ",
      accountNumber: "ଖାତା ନମ୍ବର​",
      accountNumberErrorMsg: "ଦୟାକରି ଖାତା ନମ୍ବର ଲେଖନ୍ତୁ",
      IFSCCode: "IFSC କୋଡ୍",
      IFSCCodeErrorMsg: "ଦୟାକରି IFSC କୋଡ୍ ଲେଖନ୍ତୁ",
      confirm: "ନିଶ୍ଚିତ କରନ୍ତୁ",
      UPIErrorMsg: "UPI ଆବଶ୍ୟକ",
      transferSuccessText: "ଆପଣଙ୍କ ନଗଦ ସ୍ଥାନାନ୍ତର​ <br> ସଫଳ ହୋଇଛି",
      successSubtitile: "ଆପଣଙ୍କ ଟଙ୍କା ପଠାଯାଇଛି!",
      goHome: "ମୁଖ୍ୟ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ",
      delegateRewards: "ଡେଲିଗେଟ୍ ପୁରସ୍କାର",
      claimList: "ଦାବି ତାଲିକା",
      noClaimsFound: "କୌଣସି ଦାବି ମିଳିଲା ନାହିଁ",
      noSuccessList: "କୌଣସି ସଫଳତା ତାଲିକା ମିଳିଲା ନାହିଁ",
      reclaimList: "ପୁନର୍ଦାବି ତାଲିକା",
      noReclaimList: "କୌଣସି ପୁନର୍ଦାବି ତାଲିକା ମିଳିଲା ନାହିଁ",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      privacyPolicy: "ଗୋପନୀୟତା ନୀତି",
      agreeText: "ଦାଖଲ କରି ଆପଣ ଆମର ସର୍ତ୍ତାବଳୀକୁ ସମ୍ମତି ଦେଉଛନ୍ତି",
      genuityCheck: "ଉତ୍ପାଦର ପ୍ରାମାଣିକତା ଯାଞ୍ଚ​",
      resendOTP: "OTP ପୁଣି ପଠାନ୍ତୁ",
      productName: "ଉତ୍ପାଦ",
      serialNO: "ସିରିଆଲ ନଂ.",
      alreadyLoginText:
        "आपका नंबर भी फार्मर कनेक्ट ऐप में लॉग इन है. लॉग इन करने के लिए ओके दबाएं।​",
      notRegisteredText:
        "आपका नंबर पंजीकृत नहीं है. कृपया डेलीगेट धमाका में भाग लेने के लिए पंजीकरण करें।​",
      loginConfirm: "लॉगिन पुष्टिकरण",
      Alert: "ସତର୍କବାଣୀ!",
      no: "नहीं",
      yes: "हाँ",
      OK: "ठीक है",
      amount: "ରାଶି",
      Date: "ତାରିଖ",
      claim: "ଦାବି କରନ୍ତୁ",
      successList: "ସଫଳତା ତାଲିକା",
      referenceId: "ରେଫରେନ୍ସ ଆଇଡି",
      status: "ସ୍ଥିତି",
      Scanmore: "ଅଧିକ ସ୍କାନ୍ କରନ୍ତୁ​",
      Rewards: "ପୁରସ୍କାର",
      reward: "ପୁରସ୍କାର",
      transfer: "ସ୍ଥାନାନ୍ତର",
      home: "ହୋମ",
      TC: "T&C",
      ProductInfo: "उत्पाद की <br>जानकारी",
      downloadBrochure: "ब्रोशर डाउनलोड <br> करें",
      programDetails: "कार्यक्रम विवरण",
      delegateParticipate: " डेलीगेट दोस्ती धमाका - भाग लें",
      termsAndConditions: "डेलीगेट धमाका- नियम और शर्तें",
      award: "ପୁରସ୍କାର",
      TermsandConditons: "ନିୟମ ଓ ସର୍ତ୍ତାବଳୀ",
      and: "आणि",
      privacyPolicy: "ଗୋପନୀୟତା ନୀତି",
      BackToHome: "ହୋମ ପେଜକୁ ଫେରନ୍ତୁ",
      ReferenceId: "ରେଫରେନ୍ସ ଆଇଡି",
      noData: "କୌଣସି ତଥ୍ୟ ଉପଲବ୍ଧ ନାହିଁ",
      mblnumberPlaceHolder: 'खुदरा विक्रेता का मोबाइल नंबर',
      name: "ନାମ",
      cottn: "କପା",
      corn: "ମକା",
      enterOTP: "OTP ପ୍ରବେଶ କରନ୍ତୁ",
      login: "ଲଗଇନ୍​",
      scanagain: "ପୁଣି ସ୍କାନ୍ କରନ୍ତୁ",
      cropErrorMsg: "ଦୟାକରି ଏକ ଫସଲ ଚୟନ କରନ୍ତୁ",
      nameErrorMsg: "ଦୟାକରି ଆପଣଙ୍କ ନାମ ଲେଖନ୍ତୁ",
      Reclaim: "ପୁନର୍ଦାବି କରନ୍ତୁ",
      Skip: "ଛାଡ଼ିଦିଅନ୍ତୁ",
      Claim: "ଦାବି କରନ୍ତୁ",
      StepsImage: "डेलीगेट डबल धमाका - ऐसे भाग लें",
      UPI: "UPI",
      bankDetails: "ବ୍ୟାଙ୍କ ବିବରଣୀ",
      sessionExperied: "ସତ୍ର ସମାପ୍ତ ହୁଆ। କୃପା କରି QR କୋଡ୍ ସ୍କେନ କରନ୍ତୁ",
      "confirmaccountNumber": "ଖାତା ନମ୍ବର ନିଶ୍ଚିତ କରନ୍ਤୁ",
      "confirmaccountNumberErrorMsg": "ଌයાકરિ નિશ્ચિત ખાતો નંબર લખો",
      "confirmAccountNumberMismatch": 'ଉપરોક્ત ખાતો નંબર અને નિશ્ચિત ખાતો નંબર મેળવત નહી',
      "invalidOTP": "অবৈধ OTP",
      "TermsandConditons": "নিয়ম ও শর্তাবলী",
      "accept": "ଗ୍ରହଣ କରନ୍ତୁ",
      "decline": "ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ",
      "UPILinkedMobileNumber": "UPI ସହ ସଂଯୁକ୍ତ ମୋବାଇଲ୍ ନମ୍ବର",
      "close": "ବନ୍ଦ କରନ୍ତୁ",
      "modify": "ପରିବର୍ତ୍ତନ କରନ୍ତୁ"
    },
  },
  mr: {
    "translation": {
      "delegate": "डेलिगेट",
      "language": "marathi",
      "profileText": "*तुमचे प्रोफाइल 'कोर्टेवा फार्मर कनेक्ट' ॲपमध्ये नोंदणीकृत केले जात आहे आणि तुम्ही भविष्यातील विपणन क्रियाकलापांसाठी तुमच्याशी संपर्क साधण्यासाठी कोर्टेव्हाला अधिकृत करता.",
      "chilli": "मिरची",
      "other": "इतर",
      "pleasescan": "कृपया प्रॉक्सीसह सीआर कोड स्कॅन करा",
      "nameErrorMsg": "कृपया तुमचे नाव प्रविष्ट करा",
      "loginLabel": "मोबाइल नंबर",
      "loginPlaceHolder": "मोबाईल क्रमांक​",
      "mobileErrorMsg": "कृपया वैध मोबाइल नंबर दर्ज करें",
      "submitBtn": "सादर करा​",
      "loginBtn": "लॉगिन",
      "otpText": "{mobileNumber} वर OTP एसएमएसद्वारे पाठवला जाईल",
      "otpError": "कृपया वैध OTP भरा",
      "OTPLabel": "OTP",
      "firstName": "पहिलं नाव",
      "firstNameErrorMsg": "कृपया पहिलं नाव प्रविष्ट करा",
      "lastName": "आडनाव",
      "lastNameErrorMsg": "कृपया आडनाव प्रविष्ट करा",
      "pincode": "पिन कोड",
      "address": "पत्ता",
      "done": "पूर्ण",
      "submit": "सबमिट करा",
      "scanTitle": "बॉटलवरील QR कोड स्कॅन करा",
      "scanning": "स्कॅनिंग",
      "scan": "स्कॅन ",
      "rescan": "पुन्हा स्कॅन करा",
      "scanSteps": "QR कोड स्कॅन करण्याचे पायर्या",
      "stepOne": "चरण 1: पाऊचवर QR कोड शोधा",
      "stepTwo": "चरण 2: QR कोड स्कॅन करा आणि सबमिट करा",
      "spinToWin": "बक्षीस जिंकण्यासाठी क्लिक करा",
      "nextStep": "पुढच्या टप्प्यावर जा",
      "scanProduct": "उत्पाद स्कॅन करा",
      "proceedToContinue": "पुढे जाण्यासाठी सुरू ठेवा",
      "SpinWheel": "रिवार्ड मिळवण्यासाठी व्हील फिरवा​",
      "congratulations": "अभिनंदन",
      "giftcongratulations": "अभिनंदन. आपण जिंकला आहात.​",
      "earned": "आपण रु. 20.00 डेलीगेटसाठी कमावले आहेत",
      "redeemCash": "रोख रिडीम करा​",
      "ClaimReward": "इनामाचा दावा करा",
      "updatesOnReward": "आपण डेलीगेटसह विजेता आहात. इनामाच्या अद्यतनांसाठी आपल्या स्थानिक कॉर्टेवा प्रतिनिधीशी संपर्क साधा",
      "paymentMode": "पेमेंट पद्धत निवडा​",
      "bankDetails": "बँक तपशील",
      "accountHolderName": "खात्याचे नाव",
      "accountHolderNameErrorMsg": "खाताधारकाचे नाव आवश्यक आहे",
      "accountNumber": "खाते क्रमांक​ ",
      "accountNumberErrorMsg": "कृपया खात्याचा क्रमांक प्रविष्ट करा",
      "IFSCCode": "IFSC कोड",
      "IFSCCodeErrorMsg": "कृपया IFSC कोड प्रविष्ट करा",
      "confirm": "पुष्टि करा​",
      "UPIErrorMsg": "UPI आवश्यक",
      "transferSuccessText": "आपले रोख हस्तांतर यशस्वी झाले​",
      "successSubtitile": "आम्ही आपले पैसे पाठविले आहेत!",
      "goHome": "मुख्य पृष्ठाकडे जा​",
      "delegateRewards": "डेलिगेट रिवार्ड्स​",
      "claimList": "दावा सूचि",
      "noClaimsFound": "कोणताही दावा सापडला नाही",
      "noSuccessList": "कोणतीही यश यादी सापडली नाही",
      "reclaimList": "रिक्लेम सूचि",
      "noReclaimList": "कोणतीही पुन्हा दावा यादी सापडली नाही",
      "termsAndConditions": "डेलीगेट धमाका- अटी व शर्ती",
      "privacyPolicy": "गोपनीयता धोरण",
      "agreeText": "सबमिट करून आपण आमच्याशी सहमत आहात",
      "genuityCheck": "उत्पादनाच्या अस्सलतेची तपासणी​",
      "resendOTP": "OTP पुन्हा पाठवा",
      "productName": "उत्पादन",
      "serialNO": "अनुक्रमांक",
      "alreadyLoginText": "आपला नंबर फार्मर कनेक्ट अॅपमध्ये लॉग इन आहे. लॉग इन करण्यासाठी ठीक आहे दाबा.",
      "notRegisteredText": "आपला नंबर नोंदणीकृत नाही. डेलीगेट धमाका मध्ये भाग घेण्यासाठी कृपया नोंदणी करा.",
      "loginConfirm": "लॉगिन पुष्टी",
      "Alert": "सावधान!",
      "no": "नाही",
      "yes": "होय",
      "OK": "ठीक आहे",
      "amount": "रुपये",
      "Date": "दिनांक",
      "claim": "दावा",
      "successList": "यशस्वी सूचि",
      "referenceId": "संदर्भ ID",
      "status": "स्थिती",
      "Scanmore": "अधिक स्कॅन करा",
      "Rewards": "रिवार्ड्स",
      "reward": "रिवार्ड्स",
      "transfer": "हस्तांतर",
      "home": "मुख्यपृष्ठ",
      "TC": "अटी व शर्ती",
      "ProductInfo": "उत्पादन माहिती",
      "downloadBrochure": "ब्रॉशर डाउनलोड करा",
      "programDetails": "कार्यक्रमाचे तपशील",
      "delegateParticipate": "डेलीगेट दोस्ती धमाका - भाग घ्या",
      "TermsandConditons": "अटी व शर्ती",
      "and": "आणि",
      "privacyPolicy": "गोपनीयता धोरण",
      "BackToHome": "मुख्य पृष्ठाकडे परत जा",
      "ReferenceId": "संदर्भ ID",
      "noData": "माहिती उपलब्ध नाही",
      "mblnumberPlaceHolder": "खुदरा विक्रेत्याचा मोबाइल नंबर",
      "name": "नाव",
      "cottn": "कापूस",
      "corn": "मका",
      "enterOTP": "OTP भरा",
      "login": "लॉगइन",
      "scanagain": "पुन्हा स्कॅन करा",
      "Reclaim": "रीक्लेम",
      "cropErrorMsg": "कृपया पिक निवडा​",
      "Skip": "Skip",
      "Claim": "दावा",
      "StepsImage": "डेलिगेट डबल धमाका - याप्रमाणे सहभागी व्हा",
      sessionExperied: "सत्र कालबाह्य झाले. कृपया QR कोड स्कॅन करा",
      "confirmaccountNumber": "खाते क्रमांकाची पुष्टी करा",
      "confirmaccountNumberErrorMsg": "कृपया खाते क्रमांकाची पुष्टी करा",
      "confirmAccountNumberMismatch": 'खाते क्रमांक पुष्टीकरण खाते क्रमांक जुळत नाही',
      "UPI": "यूपीआय",
      "invalidOTP": "अमान्य ओटीपी",
      "TermsandConditons": "अटी व शर्ती",
      "accept": "स्वीकारा",
      "decline": "नकारा",
      "UPILinkedMobileNumber": "UPI शी जोडलेला मोबाईल क्रमांक",
      "close": "बंद करा",
      "modify": "बदला"
    },
  },
  te: {
    "translation": {
      "delegate": "డెలిగేట్",
      "language": "telugu",
      "profileText": "*మీ ప్రొఫైల్  'Corteva Farmer Connect' యాప్‌లో నమోదు చేయబడుతోంది మరియు భవిష్యత్ మార్కెటింగ్ కార్యకలాపాల కోసం మిమ్మల్ని సంప్రదించడానికి మీరు కోర్టెవాకు అధికారం ఇస్తున్నారు.",
      "chilli": "మిరపకాయ",
      "other": "ఇతరులు",
      "pleasescan": "దయచేసి కొనసాగించడానికి QR కోడ్‌ని స్కాన్ చేయండి",
      "cropErrorMsg": "దయచేసి పంట ఎంచుకోండి​",
      "nameErrorMsg": "దయచేసి మీ పేరు నమోదు చేయండి",
      "Reclaim": "తిరిగి పొందండి",
      "loginLabel": "మొబైల్ నంబర్",
      "loginPlaceHolder": "మొబైల్ నంబర్",
      "mobileErrorMsg": "దయచేసి మొబైల్ నంబర్‌ను నమోదు చేయండి",
      "submitBtn": "సమర్పించండి",
      "loginBtn": "లాగిన్",
      "otpText": "OTP SMS ద్వారా {mobileNumber} కు పంపబడుతుంది",
      "otpError": "దయచేసి చెల్లుబాటయ్యే ఓటీపీ నమోదు చేయండి​",
      "OTPLabel": "OTP",
      "firstName": "మొదటి పేరు",
      "firstNameErrorMsg": "దయచేసి మొదటి పేరు నమోదు చేయండి",
      "lastName": "చివరి పేరు",
      "lastNameErrorMsg": "దయచేసి చివరి పేరు నమోదు చేయండి",
      "pincode": "పిన్ కోడ్",
      "address": "చిరునామా",
      "done": "పూర్తయింది",
      "submit": "సమర్పించండి",
      "scanTitle": "బాటిల్ పై క్యూఆర్ కోడ్ స్కాన్ చేయండి",
      "scanning": "స్కానింగ్",
      "scan": "స్కాన్ చేయండి",
      "rescan": "మళ్లీ స్కాన్ చేయండి",
      "scanSteps": "QR కోడ్ స్కాన్ చేసే దశలు",
      "stepOne": "దశ 1: పౌచ్‌లో QR కోడ్‌ను కనుగొనండి",
      "stepTwo": "దశ 2: QR కోడ్‌ను స్కాన్ చేసి సమర్పించండి",
      "spinToWin": "బహుమతి గెలుచుకోవడానికి క్లిక్ చేయండి",
      "nextStep": "తదుపరి దశకు వెళ్లండి",
      "scanProduct": "ఉత్పత్తి స్కాన్ చేయండి",
      "proceedToContinue": "కొనసాగించడానికి ముందుకు వెళ్లండి",
      "SpinWheel": "రివార్డ్ పొందడానికి వీల్ ను తిప్పండి",
      "congratulations": "అభినందనలు",
      "giftcongratulations": "అభినందనలు .మీరు విజేత.",
      "earned": "మీరు రూ. 20.00 డెలిగేట్ కోసం సంపాదించారు",
      "redeemCash": "క్యాష్ రెడీమ్ చేయండి",
      "ClaimReward": "మరింత స్కాన్ చేయండి",
      "updatesOnReward": "మీరు డెలిగేట్‌తో విజేత. బహుమతి వివరాల కోసం మీ స్థానిక కార్టేవా ప్రతినిధిని సంప్రదించండి",
      "paymentMode": "చెల్లింపు మోడ్ ఎంచుకోండి",
      "bankDetails": "బ్యాంక్ వివరాలు",
      "accountHolderName": "అకౌంట్ పేరు​",
      "accountHolderNameErrorMsg": "అకౌంట్ పేరు అవసరం",
      "accountNumber": "అకౌంట్ నంబర్ ​",
      "accountNumberErrorMsg": "దయచేసి ఖాతా సంఖ్యను నమోదు చేయండి",
      "IFSCCode": "ఐఎఫ్ఎస్ సీ కోడ్ ",
      "IFSCCodeErrorMsg": "దయచేసి IFSC కోడ్‌ను నమోదు చేయండి",
      "confirm": "నిర్థారించండి",
      "UPIErrorMsg": "UPI అవసరం",
      "transferSuccessText": "మీ నగదు బదిలీ విజయవంతమైంది",
      "successSubtitile": "మేము మీకు మీ డబ్బును పంపించాం!",
      "goHome": "మళ్లీ హోం పేజీకి రావడం​",
      "delegateRewards": "డెలిగేట్ రివార్డ్స్",
      "claimList": "క్లెయిమ్ జాబితా",
      "noClaimsFound": "ఏమైనా దావా లభించలేదు",
      "noSuccessList": "ఏమైనా విజయ జాబితా లేదు",
      "reclaimList": "పునః క్లెయిమ్ జాబితా",
      "noReclaimList": "ఏమైనా మళ్లీ దావా జాబితా లేదు",
      "termsAndConditions": "డెలిగేట్ ధమాకా - నిబంధనలు మరియు షరతులు",
      "privacyPolicy": "గోప్యతా విధానం",
      "agreeText": "సమర్పించడం ద్వారా మీరు మమ్మల్ని అంగీకరిస్తున్నారు",
      "genuityCheck": "ఉత్పత్తి యొక్క ప్రామాణికత తనిఖీ",
      "resendOTP": "OTP మళ్లీ పంపండి",
      "productName": "ఉత్పత్తి",
      "serialNO": "క్రమ సంఖ్య",
      "alreadyLoginText": "మీ నంబర్ కూడా ఫార్మర్ కనెక్ట్ యాప్‌లో లాగిన్ అయ్యింది. లాగిన్ చేయడానికి OK నొక్కండి.",
      "notRegisteredText": "మీ నంబర్ నమోదు కాలేదు. డెలిగేట్ ధమాకాలో పాల్గొనడానికి దయచేసి నమోదు చేసుకోండి.",
      "loginConfirm": "లాగిన్ నిర్ధారణ",
      "Alert": "హెచ్చరిక!",
      "no": "కాదు",
      "yes": "అవును",
      "OK": "సరే",
      "amount": "రూపాయలు",
      "Date": "తేదీ",
      "claim": "దావా",
      "successList": "విజయవంతమైన జాబితా",
      "referenceId": "సందర్భ ID",
      "status": "స్థితి",
      "Scanmore": "మరిన్ని స్కాన్ చేయండి ​",
      "Rewards": "రివార్డ్స్ ",
      "reward": "రివార్డ్స్ ",
      "transfer": "బదిలీ చేయండి",
      "home": "హోమ్",
      "TC": "T&C",
      "ProductInfo": "ఉత్పత్తి <br>వివరాలు",
      "downloadBrochure": "బ్రోచర్‌ను <br>డౌన్‌లోడ్ చేయండి",
      "programDetails": "ప్రోగ్రాం వివరాలు",
      "delegateParticipate": "డెలిగేట్ స్నేహధమాకా - పాల్గొనండి",
      "termsAndConditions": "డెలిగేట్ ధమాకా - నిబంధనలు మరియు షరతులు",
      "award": "బహుమతి",
      "TermsandConditons": "నిబంధనలు మరియు షరతులు",
      "and": "మరియు",
      "privacyPolicy": "గోప్యతా విధానం",
      "BackToHome": "మళ్లీ హోం పేజీకి రావడం​",
      "ReferenceId": "రిఫరెన్స్ ఐడీ",
      "noData": "డేటా లేదు",
      "mblnumberPlaceHolder": "రిటైలర్ మొబైల్ నంబర్",
      "name": "పేరు",
      "cottn": "పత్తి",
      "corn": "మొక్కజొన్న",
      "enterOTP": "ఓటీపీ నమోదు చేయండి  ",
      "login": "లాగిన్ చేయండి",
      "scanagain": "మళ్లీ స్కాన్ చేయండి",
      "Skip": "Skip",
      "Claim": "దావా",
      "StepsImage": "డబుల్ ధమాకా ప్రతినిధి- ఇలా పాల్గొనండి",
      "sessionExperied": "సెషన్ గడువు ముగిసింది. దయచేసి QR కోడ్‌ని స్కాన్ చేయండి",
      "confirmaccountNumber": "ఖాతా సంఖ్యను నిర్ధారించండి",
      "confirmaccountNumberErrorMsg": "దయచేసి ఖాతా సంఖ్యను నిర్ధారించండి",
      "confirmAccountNumberMismatch": 'ఖాతా సంఖ్య నిర్ధారణ ఖాతా సంఖ్య సరిపోలడం లేద',
      "UPI": "యుపిఐ",
      "invalidOTP": "చెల్లని OTP",
      "TermsandConditons": "నిబంధనలు మరియు షరతులు",
      "accept": "అంగీకరించు",
      "decline": "తిరస్కరించు",
      "UPILinkedMobileNumber": "UPIతో అనుసంధానమైన మొబైల్ నంబర్",
      "close": "మూసివేయి",
      "modify": "మార్చండి"

    },
  },
  kn: {
    "translation": {
      "delegate": "ಡಿಲಿಗೇಟ್",
      "chilli": "ಮೆಣಸಿನಕಾಯಿ",
      "language": "kannada",
      "other": "ಇತರರು",
      "profileText": "*ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು 'Corteva Farmer Connect' ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿ ನೋಂದಾಯಿಸಲಾಗುತ್ತಿದೆ ಮತ್ತು ಭವಿಷ್ಯದ ಮಾರ್ಕೆಟಿಂಗ್ ಚಟುವಟಿಕೆಗಳಿಗಾಗಿ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಲು ನೀವು ಕಾರ್ಟೆವಾಗೆ ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ.",
      "pleasescan": "ಮುಂದುವರೆಯಲು ದಯವಿಟ್ಟು QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "cropErrorMsg": "ದಯವಿಟ್ಟು ಬೆಳೆ ಆಯ್ಕೆ ಮಾಡಿ",
      "nameErrorMsg": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
      "Reclaim": "ಹಿಂಪಡೆಯಿರಿ",
      "loginLabel": "ಮೊಬೈಲ್ ನಂಬರ್",
      "loginPlaceHolder": "ಮೊಬೈಲ್ ನಂಬರ್",
      "mobileErrorMsg": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ",
      "submitBtn": "ಸಲ್ಲಿಸಿ",
      "loginBtn": "ಲಾಗಿನ್",
      "otpText": "OTP {mobileNumber} ಗೆ SMS ಮೂಲಕ ಕಳುಹಿಸಲಾಗುತ್ತದೆ",
      "otpError": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಒಟಿಪಿ ನಮೂದಿಸಿ​",
      "OTPLabel": "OTP",
      "firstName": "ಮೊದಲ ಹೆಸರು",
      "firstNameErrorMsg": "ದಯವಿಟ್ಟು ಮೊದಲ ಹೆಸರು ನಮೂದಿಸಿ",
      "lastName": "ಕೊನೆಯ ಹೆಸರು",
      "lastNameErrorMsg": "ದಯವಿಟ್ಟು ಕೊನೆಯ ಹೆಸರು ನಮೂದಿಸಿ",
      "pincode": "ಪಿನ್ ಕೋಡ್",
      "address": "ವಿಳಾಸ",
      "done": "ಮುಗಿಯಿತು",
      "submit": "ಸಲ್ಲಿಸಿ",
      "scanTitle": "ಬಾಟಲಿಯ ಮೇಲೆ ಕ್ಯು ಆರ್ ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ​",
      "scanning": "ಸ್ಕ್ಯಾನಿಂಗ್",
      "scan": "ಸ್ಕ್ಯಾನ್",
      "rescan": "ಮತ್ತೊಮ್ಮೆಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿರಿ",
      "scanSteps": "QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡುವ ಹಂತಗಳು",
      "stepOne": "ಹಂತ 1: ಪೌಚ್‌ನಲ್ಲಿ QR ಕೋಡ್ ಅನ್ನು ಹುಡುಕಿ",
      "stepTwo": "ಹಂತ 2: QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಮತ್ತು ಸಲ್ಲಿಸಿ",
      "spinToWin": "ಬಹುಮಾನ ಗೆಲ್ಲಲು ಕ್ಲಿಕ್ ಮಾಡಿ​",
      "nextStep": "ಮುಂದಿನ ಹಂತಕ್ಕೆ ಹೋಗಿ",
      "scanProduct": "ಉತ್ಪನ್ನವನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "proceedToContinue": "ಮುಂದುವರಿಯಲು ಮುಂದಕ್ಕೆ ಹೋಗಿ",
      "SpinWheel": "ರಿವಾರ್ಡ್ ಪಡೆದುಕೊಳ್ಳಲು ಚಕ್ರ ತಿರುಗಿಸಿ​",
      "congratulations": "ಅಭಿನಂದನೆಗಳು",
      "giftcongratulations": "ಅಭಿನಂದನೆ. ನೀವು ವಿಜಯಿಯಾಗಿದ್ದೀರಿ​",
      "earned": "ನೀವು ರೂ. ಗಳಿಸಿದ್ದಾರೆ. ಡೆಲಿಗೇಟ್‌ಗಾಗಿ 20.00 ನಗದು",
      "redeemCash": "ನಗದು ರೆಡೀಮ್ ಮಾಡಿಕೊಳ್ಳಿ​",
      "ClaimReward": "ಬಹುಮಾನವನ್ನು ಪಡೆಯಿರಿ",
      "updatesOnReward": "ನೀವು ಡೆಲಿಗೇಟ್‌ನೊಂದಿಗೆ ವಿಜೇತ. ಬಹುಮಾನದ ವಿವರಗಳಿಗಾಗಿ ನಿಮ್ಮ ಸ್ಥಳೀಯ ಕಾರ್ಟೇವಾ ಪ್ರತಿನಿಧಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
      "paymentMode": "ಪಾವತಿ ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ​",
      "bankDetails": "ಬ್ಯಾಂಕ್ ವಿವರಗಳು",
      "accountHolderName": "ಖಾತೆ ಹೆಸರು",
      "accountHolderNameErrorMsg": "ಖಾತೆಧಾರಕನ ಹೆಸರು ಅಗತ್ಯವಿದೆ",
      "accountNumber": "ಖಾತೆ ಸಂಖ್ಯೆ",
      "accountNumberErrorMsg": "ದಯವಿಟ್ಟು ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
      "IFSCCode": "IFSC ಕೋಡ್",
      "IFSCCodeErrorMsg": "ದಯವಿಟ್ಟು IFSC ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
      "confirm": "ದೃಢೀಕರಿಸಿ",
      "UPIErrorMsg": "UPI ಅಗತ್ಯವಿದೆ",
      "transferSuccessText": "ನಿಮ್ಮ ನಗದು ವರ್ಗಾವಣೆ ಯಶಸ್ವಿಯಾಗಿದೆ​",
      "successSubtitile": "ನಾವು ನಿಮ್ಮ ಹಣವನ್ನು ಕಳುಹಿಸಿದ್ದೇವೆ!",
      "goHome": "ಹೋಂ ಗೆ ಹೋಗಿ​",
      "delegateRewards": "ಡೆಲಿಗೇಟ್ ರಿವಾರ್ಡ್ಸ್​",
      "claimList": "ಕ್ಲೈಮ್ ಪಟ್ಟಿ​",
      "noClaimsFound": "ಯಾವುದೇ ದಾವಾ ಕಂಡುಬಂದಿಲ್ಲ",
      "noSuccessList": "ಯಾವುದೇ ಯಶಸ್ಸಿನ ಪಟ್ಟಿ ಲಭ್ಯವಿಲ್ಲ",
      "reclaimList": "ರೀಕ್ಲೈಮ್ ಪಟ್ಟಿ​",
      "noReclaimList": "ಯಾವುದೇ ಮರುದಾವಾ ಪಟ್ಟಿ ಲಭ್ಯವಿಲ್ಲ",
      "termsAndConditions": "ಡೆಲಿಗೇಟ್ ಧಮಾಕಾ- ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "privacyPolicy": "ಗೌಪ್ಯತಾ ನೀತಿ",
      "agreeText": "ಸಲ್ಲಿಸುವ ಮೂಲಕ ನೀವು ನಮ್ಮೊಂದಿಗೆ ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ",
      "genuityCheck": "ಉತ್ಪನ್ನದ ಪ್ರಮಾಣೀಕರಣ ಪರೀಕ್ಷೆ​",
      "resendOTP": "OTP ಮರುಕಳುಹಿಸಿ",
      "productName": "ಉತ್ಪನ್ನ",
      "serialNO": "ಕ್ರಮ ಸಂಖ್ಯೆ​",
      "alreadyLoginText": "ನಿಮ್ಮ ಸಂಖ್ಯೆ ಫಾರ್ಮರ್ ಕನೆಕ್ಟ್ ಆಪ್‌ನಲ್ಲಿ ಲಾಗಿನ್ ಆಗಿದೆ. ಲಾಗಿನ್ ಮಾಡಲು OK ಒತ್ತಿ.",
      "notRegisteredText": "ನಿಮ್ಮ ಸಂಖ್ಯೆ ನೋಂದಾಯಿಸಲ್ಪಡಿಲ್ಲ. ದಯವಿಟ್ಟು ಡೆಲಿಗೇಟ್ ಧಮಾಕಾದಲ್ಲಿ ಪಾಲ್ಗೊಳ್ಳಲು ನೋಂದಾಯಿಸು.",
      "loginConfirm": "ಲಾಗಿನ್ ದೃಢೀಕರಣ",
      "Alert": "ಎಚ್ಚರಿಕೆ!",
      "no": "ಇಲ್ಲ",
      "yes": "ಹೌದು",
      "OK": "ಸರಿ",
      "amount": "ರೂ",
      "Date": "ದಿನಾಂಕ",
      "claim": "ದಾವಾ",
      "successList": "ಯಶಸ್ಸಿನ ಪಟ್ಟಿ​",
      "referenceId": "ಉಲ್ಲೇಖ ಐಡಿ​",
      "status": "ಸ್ಥಿತಿ",
      "Scanmore": "ಮತ್ತಷ್ಟು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ​",
      "Rewards": "ರಿವಾರ್ಡ್ಸ್",
      "reward": "ರಿವಾರ್ಡ್ಸ್",
      "transfer": "ವರ್ಗಾವಣೆ",
      "home": "ಮುಖಪುಟ",
      "TC": "T&C",
      "ProductInfo": "ಉತ್ಪನ್ನ <br>ವಿವರಗಳು",
      "downloadBrochure": "ಬ್ರೋಶರ್ ಅನ್ನು <br>ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
      "programDetails": "ಕಾರ್ಯಕ್ರಮದ ವಿವರಗಳು",
      "delegateParticipate": "ಡಿಲಿಗೇಟ್ “ಡಬಲ್ ಧಮಾಕಾದಲ್ಲಿ” ಪಾಲ್ಗೊಳ್ಳಿ",
      "termsAndConditions": "ಡೆಲಿಗೇಟ್ ಧಮಾಕಾ- ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "award": "ಬಹುಮಾನ",
      "TermsandConditons": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "and": "ಮತ್ತು",
      "privacyPolicy": "ಗೌಪ್ಯತಾ ನೀತಿ",
      "BackToHome": "ಪುನಃ ಹೋಂ ಪುಟಕ್ಕೆ​",
      "ReferenceId": "ಉಲ್ಲೇಖ ಐಡಿ",
      "noData": "ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
      "mblnumberPlaceHolder": "ರೆಟೈಲರ್ ಮೊಬೈಲ್ ನಂಬರ್",
      "name": "ಹೆಸರು",
      "cottn": "ಹತ್ತಿ",
      "corn": "ಮೆಕ್ಕೆಜೋಳ",
      "enterOTP": "ಒಟಿಪಿ ನಮೂದಿಸಿ",
      "login": "ಲಾಗಿನ್",
      "scanagain": "ಮತ್ತೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "Skip": "Skip",
      "Claim": "ಕ್ಲೈಮ್",
      "StepsImage": "ಡೆಲಿಗೇಟ್ ಡಬಲ್ ಧಮಾಕಾ- ಹೀಗೆ ಪಾಲ್ಗೊಳ್ಳಿ",
      "sessionExperied": "ಸೆಷನ್ ಅವಧಿ ಮೀರಿದೆ. ದಯವಿಟ್ಟು QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "confirmaccountNumber": "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
      "confirmaccountNumberErrorMsg": "ದಯವಿಟ್ಟು ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ ನಮೂದಿಸಿ",
      "confirmAccountNumberMismatch": 'ಖಾತೆ ಸಂಖ್ಯೆ ದೃಢೀಕರಣ ಖಾತೆ ಸಂಖ್ಯೆ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ',
      "UPI": "ಯುಪಿಐ",
      "invalidOTP": "ಅಮಾನ್ಯ OTP",
      "TermsandConditons": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "accept": "ಸ್ವೀಕರಿಸಿ",
      "decline": "ನಿರಾಕರಿಸಿ",
      "UPILinkedMobileNumber": "UPIಗೆ ಲಿಂಕ್ ಮಾಡಲಾದ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
      "close": "ಮುಚ್ಚಿ",
      "modify": "ಬದಲಾಯಿಸಿ"
    },
  },
  pa: {
    "translation": {
      "delegate": "ਡੈਲੀਗੇਟ",
      "language": "punjabi",
      "chilli": "ਮਿਰਚ",
      "other": "ਹੋਰ",
      "profileText": "*ਤੁਹਾਡੀ ਪ੍ਰੋਫਾਈਲ 'Corteva Farmer Connect' ਐਪ ਵਿੱਚ ਦਰਜ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ ਅਤੇ ਭਵਿੱਖ ਦੀ ਮਾਰਕੀਟਿੰਗ ਕਾਰਜਵਾਹੀਆਂ ਲਈ ਤੁਸੀਂ ਕੋਰਟੇਵਾ ਨੂੰ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਦੇ ਰਹੇ ਹੋ।",
      "pleasescan": "ਕਿਰਪਾ ਕਰਕੇ ਅੱਗੇ ਵਧਣ ਲਈ QR ਕੋਡ ਨੂੰ ਸਕੈਨ ਕਰੋ",
      "cropErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਫ਼ਸਲ ਚੁਣੋ​​",
      "nameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
      "Reclaim": "ਪਿੱਛੇ ਹੋਵੋ",
      "loginLabel": "ਮੋਬਾਈਲ ਨੰਬਰ",
      "loginPlaceHolder": "ਮੋਬਾਈਲ ਨੰਬਰ",
      "mobileErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
      "submitBtn": "ਜਮ੍ਹਾਂ ਕਰੋ ",
      "loginBtn": "ਲਾੱਗਇਨ ਕਰੋ ​",
      "otpText": "OTP SMS ਰਾਹੀਂ {mobileNumber} 'ਤੇ ਭੇਜਿਆ ਜਾਵੇਗਾ",
      "otpError": "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ ​",
      "OTPLabel": "OTP",
      "firstName": "ਪਹਿਲਾ ਨਾਂ",
      "firstNameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾ ਨਾਮ ਦਰਜ ਕਰੋ",
      "lastName": "ਆਖਰੀ ਨਾਂਮ",
      "lastNameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਆਖਰੀ ਨਾਮ ਦਰਜ ਕਰੋ",
      "pincode": "ਪਿੰਨ ਕੋਡ",
      "address": "ਪਤਾ",
      "done": "ਪੂਰਾ ਕੀਤਾ",
      "submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
      "scanTitle": "ਬੋਤਲ ਦਾ QR ਕੋਡ ਸਕੈਨ ਕਰੋ ​",
      "scanning": "ਸਕੈਨਿੰਗ",
      "scan": "ਸਕੈਨ ਕਰੋ ​",
      "rescan": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "scanSteps": "QR ਕੋਡ ਨੂੰ ਸਕੈਨ ਕਰਨ ਲਈ ਕਦਮ",
      "stepOne": "ਕਦਮ 1: ਪਾਊਚ ਵਿੱਚ QR ਕੋਡ ਲੱਭੋ",
      "stepTwo": "ਕਦਮ 2: ਸਕੈਨ ਕਰੋ ਅਤੇ QR ਕੋਡ ਦਰਜ ਕਰੋ",
      "spinToWin": "ਇਨਾਮ ਜਿੱਤਣ ਲਈ ਕਲਿਕ ਕਰੋ​",
      "nextStep": "ਅਗਲੇ ਪੜਾਅ ਤੇ ਜਾਓ",
      "scanProduct": "ਉਤਪਾਦ ਨੂੰ ਸਕੈਨ ਕਰੋ",
      "proceedToContinue": "ਅੱਗੇ ਵਧਣ ਲਈ ਜਾਰੀ ਰੱਖੋ",
      "SpinWheel": "ਇਨਾਮ ਜਿੱਤਣ ਲਈ ਚੱਕਾ ਘੁੰਮਾਓ ",
      "congratulations": "ਵਧਾਈ ਹੋਵੇ",
      "giftcongratulations": "ਵਧਾਈ ਹੋਵੇ। ਤੁਸੀਂ ਜੇਤੂ ਹੋ।",
      "earned": "ਤੁਹਾਨੂੰ ਰੁ. ਡੈਲੀਗੇਟ ਲਈ 20.00 ਕਮਾਏ",
      "redeemCash": "ਕੈਸ਼ ਰੀਡੀਮ ਕਰੋ ​",
      "ClaimReward": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "updatesOnReward": "ਤੁਸੀਂ ਡੈਲੀਗੇਟ ਦੇ ਨਾਲ ਜੇਤੂ ਹੋ। ਤੋਹਫ਼ੇ ਦੇ ਵੇਰਵਿਆਂ ਲਈ ਆਪਣੇ ਸਥਾਨਕ ਕਾਰਟੇਵਾ ਪ੍ਰਤੀਨਿਧੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
      "paymentMode": "ਭੁਗਤਾਨ ਦਾ ਤਰੀਕਾ ਚੁਣੋ ​",
      "bankDetails": "ਬੈਂਕ ਵੇਰਵੇ",
      "accountHolderName": "ਖਾਤੇ ਦਾ ਨਾਂਅ ​",
      "accountHolderNameErrorMsg": "ਖਾਤੇ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
      "accountNumber": "ਖਾਤਾ ਨੰਬਰ ​​",
      "accountNumberErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਖਾਤਾ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
      "IFSCCode": "IFSC ਕੋਡ ",
      "IFSCCodeErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ IFSC ਕੋਡ ਦਾਖਲ ਕਰੋ",
      "confirm": "ਪੁਸ਼ਟੀ ਕਰੋ ",
      "UPIErrorMsg": "UPI ਦੀ ਲੋੜ ਹੈ",
      "transferSuccessText": "ਤੁਹਾਡਾ ਨਕਦ ਤਬਾਦਲਾ ਸਫਲ ਹੈ ​",
      "successSubtitile": "ਅਸੀਂ ਤੁਹਾਨੂੰ ਤੁਹਾਡੇ ਪੈਸੇ ਭੇਜੇ!",
      "goHome": "ਹੋਮ ਪੇਜ ’ਤੇ ਵਾਪਸ ਜਾਓ ​​",
      "delegateRewards": "ਡੈਲੀਗੇਟ ਰਿਵਾਰਡ",
      "claimList": "ਕਲੇਮ ਸੂਚੀ",
      "noClaimsFound": "ਕੋਈ ਦਾਅਵੇ ਨਹੀਂ ਮਿਲੇ",
      "noSuccessList": "ਕੋਈ ਜਿੱਤ ਸੂਚੀ ਹੈ",
      "reclaimList": "ਰਿਕਲੇਮ ਸੂਚੀ ​",
      "noReclaimList": "ਫਿਰ ਵੀ ਕੋਈ ਦਾਅਵਾ ਸੂਚੀ ਨਹੀਂ",
      "termsAndConditions": "ਡੈਲੀਗੇਟ ਬਲਾਸਟ - ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      "privacyPolicy": "ਪਰਾਈਵੇਟ ਨੀਤੀ",
      "agreeText": "ਦਰਜ ਕਰਕੇ ਤੁਸੀਂ ਸਾਡੇ ਨਾਲ ਸਹਿਮਤ ਹੋ",
      "genuityCheck": "ਉਤਪਾਦ ਦੀ ਅਸਲੀਅਤ ਦੀ ਜਾਂਚ",
      "resendOTP": "OTP ਦੁਬਾਰਾ ਭੇਜੋ",
      "productName": "ਉਤਪਾਦ ",
      "serialNO": "ਲੜੀ ਸੰਖਿਆ ",
      "alreadyLoginText": "ਤੁਹਾਡਾ ਨੰਬਰ ਫਾਰਮਰ ਕਨੈਕਟ ਐਪ ਵਿੱਚ ਵੀ ਲੌਗਇਨ ਹੈ। ਲੌਗ ਇਨ ਕਰਨ ਲਈ ਠੀਕ 'ਤੇ ਟੈਪ ਕਰੋ।",
      "notRegisteredText": "ਤੁਹਾਡਾ ਨੰਬਰ ਰਜਿਸਟਰਡ ਨਹੀਂ ਸੀ। ਕਿਰਪਾ ਕਰਕੇ ਡੈਲੀਗੇਟ ਧਮਾਕੇ ਵਿੱਚ ਹਿੱਸਾ ਲੈਣ ਲਈ ਰਜਿਸਟਰ ਕਰੋ।",
      "loginConfirm": "ਲਾਗਇਨ ਪੁਸ਼ਟੀ",
      "Alert": "ਚੇਤਾਵਨੀ!",
      "no": "ਨਹੀਂ",
      "yes": "ਹਾਂ",
      "OK": "ਠੀਕ ਹੈ",
      "amount": "ਰੁਪਏ",
      "Date": "ਤਾਰੀਖ",
      "claim": "ਕਲੇਮ",
      "successList": "ਸਫਲਤਾ ਸੂਚੀ​",
      "referenceId": "ਰੈਫਰੈਂਸ ਆਈਡੀ​",
      "status": "ਸਥਿਤੀ",
      "Scanmore": "ਹੋਰ ਸਕੈਨ ਕਰੋ​",
      "Rewards": "ਰਿਵਾਰਡ",
      "reward": "ਰਿਵਾਰਡ ",
      "transfer": "ਟ੍ਰਾਂਸਫ਼ਰ ਕਰੋ​",
      "home": "ਘਰ",
      "TC": "T&C",
      "ProductInfo": "ਉਤਪਾਦ <br>ਵਿਵਰਾਲੁ",
      "downloadBrochure": "ਬਰੋਸ਼ਰ ਡਾਊਨਲੋਡ ਕਰੋ<br>",
      "programDetails": "ਪ੍ਰੋਗਰਾਮ ਦੇ ਵੇਰਵੇ",
      "delegateParticipate": "ਡੈਲੀਗੇਟ ਦੋਸਤੀ - ਹਿੱਸਾ ਲਓ",
      "termsAndConditions": "ਡੈਲੀਗੇਟ ਬਲਾਸਟ - ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      "award": "ਉਪਹਾਰ",
      "TermsandConditons": "ਨਿਬੰਧਨ ਅਤੇ ਸ਼ਰਤਾਂ",
      "and": "ਅਤੇ",
      "privacyPolicy": "ਪਰਾਈਵੇਟ ਨੀਤੀ",
      "BackToHome": "ਹੋਮ ਪੇਜ ’ਤੇ ਵਾਪਸ ਜਾਓ ​​",
      "ReferenceId": "ਰੈਫਰੈਂਸ ਆਈਡੀ ​",
      "noData": "ਕੋਈ ਡਾਟਾ ਨਹੀਂ",
      "mblnumberPlaceHolder": "ਰਿਟੇਲਰ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
      "name": "ਨਾਂਅ",
      "cottn": "ਕਪਾਸ",
      "corn": "ਮੱਕਾ",
      "enterOTP": "ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ",
      "login": "ਲਾੱਗਇਨ ਕਰੋ",
      "scanagain": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "Skip": "Skip",
      "Claim": "ਕਲੇਮ",
      "StepsImage": "ਡੇਲੀਗੇਟ ਡਬਲ ਧਮਾਕਾ-ਇਵੇਂ ਭਾਗ ਲਵੋ",
      "sessionExperied": "ਸੈਸ਼ਨ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ। ਕਿਰਪਾ ਕਰਕੇ QR ਕੋਡ ਨੂੰ ਸਕੈਨ ਕਰੋ",
      "confirmaccountNumber": "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
      "confirmaccountNumberErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਖਾਤਾ ਨੰਬਰ ਦਰਜ ਕਰੋ",
      "confirmAccountNumberMismatch": 'ਖਾਤਾ ਨੰਬਰ ਪੁਸ਼ਟੀਕਰਨ ਖਾਤਾ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ',
      "UPI": "ਯੂਪੀਆਈ",
      "invalidOTP": "ਅਵੈਧ OTP",
      "TermsandConditons": "ਨਿਬੰਧਨ ਅਤੇ ਸ਼ਰਤਾਂ",
      "accept": "ਸਵੀਕਾਰ ਕਰੋ",
      "decline": "ਅਸਵੀਕਾਰ ਕਰੋ",
      "UPILinkedMobileNumber": "UPI ਨਾਲ ਜੁੜਿਆ ਮੋਬਾਈਲ ਨੰਬਰ",
      "close": "ਬੰਦ ਕਰੋ",
      "modify": "ਸੋਧੋ"
    },
  },
  gu: {
    "translation": {
      "delegate": "ડેલિગેટ",
      "chilli": "મરચાં",
      "language": "gujarati",
      "other": "અન્ય",
      "profileText": "*તમારી પ્રોફાઇલ 'Corteva Farmer Connect' એપમાં રજીસ્ટર કરવામાં આવી રહી છે અને તમે Corteva ને ભાવિ માર્કેટિંગ પ્રવૃત્તિઓ માટે તમારો સંપર્ક કરવા માટે અધિકૃત કરો છો.",
      "pleasescan": "કૃપા કરીને આગળ વધવા માટે QR કોડ સ્કેન કરો",
      "cropErrorMsg": "કૃપા કરીને પાક પસંદ કરો​",
      "nameErrorMsg": "કૃપા કરીને તમારું નામ દાખલ કરો",
      "Reclaim": "પાછુ મડે",
      "loginLabel": "મોબાઇલ નંબર",
      "loginPlaceHolder": "મોબાઇલ નંબર",
      "mobileErrorMsg": "કૃપા કરીને મોબાઇલ નંબર દાખલ કરો",
      "submitBtn": "સબમિટ કરો",
      "loginBtn": "નોંધણી કરો",
      "otpText": "OTP SMS દ્વારા {mobileNumber} પર મોકલવામાં આવશે",
      "otpError": "કૃપા કરીને छेल्लुबातुये OTP દાખલ કરો​",
      "OTPLabel": "OTP",
      "firstName": "પ્રથમ નામ",
      "firstNameErrorMsg": "કૃપા કરીને પ્રથમ નામ દાખલ કરો",
      "lastName": "છેલ્લું નામ",
      "lastNameErrorMsg": "કૃપા કરીને છેલ્લું નામ દાખલ કરો",
      "pincode": "પીન કોડ",
      "address": "સરનામું",
      "done": "પૂર્ણ",
      "submit": "સબમિટ કરો",
      "scanTitle": "બોટલ પર QR કોડ સ્કેન કરો",
      "scanning": "સ્કેનિંગ",
      "scan": "સ્કેન",
      "rescan": "ફરીથી સ્કેન કરો",
      "scanSteps": "QR કોડ સ્કેન કરવાનાં પગલાં",
      "stepOne": "પગલું 1: પાઉચમાં QR કોડ શોધો",
      "stepTwo": "પગલું 2: સ્કેન કરો અને QR કોડ સબમિટ કરો",
      "spinToWin": "ઇનામ જીતવા માટે ક્લિક કરો",
      "nextStep": "આગળના તબક્કે જાઓ",
      "scanProduct": "ઉત્પાદન સ્કેન કરો",
      "proceedToContinue": "આગળ વધવા માટે ચાલુ રાખો",
      "SpinWheel": "ઇનામ જીતવા માટે વ્હીલ સ્પિન કરો",
      "congratulations": "અભિનંદન",
      "giftcongratulations": "અભિનંદન. તમે વિજેતા છો",
      "earned": "તમને રૂ. 20.00 પ્રતિનિધિ માટે કમાવ્યા",
      "redeemCash": "કેશબેક ",
      "ClaimReward": "અને સ્કેન કરો",
      "updatesOnReward": "તમે પ્રતિનિધિ સાથે વિજેતા છો. ભેટની વિગતો માટે તમારા સ્થાનિક કાર્ટેવાના પ્રતિનિધિનો સંપર્ક કરો",
      "paymentMode": "ચુકવણી મોડ પસંદ કરો",
      "bankDetails": "બેંકની વિગત",
      "accountHolderName": "ખાતાનું નામ​",
      "accountHolderNameErrorMsg": "એકાઉન્ટ નામ જરૂરી છે",
      "accountNumber": "ખાતા નંબર​",
      "accountNumberErrorMsg": "કૃપા કરીને એકાઉન્ટ નંબર દાખલ કરો",
      "IFSCCode": "IFSC કોડ",
      "IFSCCodeErrorMsg": "કૃપા કરીને IFSC કોડ દાખલ કરો",
      "confirm": "નક્કી કરો",
      "UPIErrorMsg": "UPI જરૂરી છે",
      "transferSuccessText": "તમારું મની ટ્રાન્સફર સફળ થયું",
      "successSubtitile": "અમે તમને તમારા પૈસા મોકલ્યા છે!",
      "goHome": "હોમ પેજ પર પાછા ફરો​",
      "delegateRewards": "પ્રતિનિધિત્વ પુરસ્કારો",
      "claimList": "દાવો યાદી",
      "noClaimsFound": "કોઈ દાવા મળ્યા નથી",
      "noSuccessList": "ત્યાં કોઈ વિજય યાદી નથી",
      "reclaimList": "ફરી દાવો યાદી",
      "noReclaimList": "કોઈપણ રીતે ફરી કોઈ દાવો યાદી",
      "termsAndConditions": "ડેલિગેટ બ્લાસ્ટ - નિયમો અને શરતો",
      "privacyPolicy": "ગોપનીયતા નીતિ",
      "agreeText": "સબમિટ કરીને તમે અમારી સાથે સંમત થાઓ છો",
      "genuityCheck": "ઉત્પાદન અધિકૃતતા તપાસો",
      "resendOTP": "OTP ફરીથી મોકલો",
      "productName": "ઉત્પાદનન",
      "serialNO": "અનુક્રમ નંબર",
      "alreadyLoginText": "તમારો નંબર ફાર્મર કનેક્ટ એપમાં પણ લોગ થયેલ છે. લોગ ઇન કરવા માટે ઓકે ટેપ કરો.",
      "notRegisteredText": "તમારો નંબર નોંધાયેલો ન હતો. ડેલિગેટ બ્લાસ્ટમાં ભાગ લેવા માટે કૃપા કરીને નોંધણી કરો.",
      "loginConfirm": "લૉગિન પુષ્ટિ",
      "Alert": "ચેતવણી!",
      "no": "ના",
      "yes": "હા",
      "OK": "બરાબર",
      "amount": "રૂપિયા",
      "Date": "તારીખ",
      "claim": "દાવાઓ",
      "successList": "સફળ યાદી",
      "referenceId": "સંદર્ભ ID",
      "status": "સંદર્ભ ID",
      "Scanmore": "વધુ સ્કેન કરો ​",
      "Rewards": "પારિતોષિકો ",
      "reward": "પારિતોષિકો ",
      "transfer": "ટ્રાન્સફર",
      "home": "ઘર",
      "TC": "T&C",
      "ProductInfo": "ઉત્પાદન <br>विवरालु",
      "downloadBrochure": "બ્રોશર ડાઉનલોડ કરો<br>",
      "programDetails": "પ્રોગ્રામ વિગતો",
      "delegateParticipate": "પ્રતિનિધિ મિત્રતા - ભાગ લો",
      "termsAndConditions": "ડેલિગેટ બ્લાસ્ટ - નિયમો અને શરતો",
      "award": "ભેટ",
      "TermsandConditons": "નિયમો અને શરત",
      "and": "અને",
      "privacyPolicy": "ગોપનીયતા નીતિ",
      "BackToHome": "હોમ પેજ પર પાછા ફરો​",
      "ReferenceId": "સંદર્ભ આઈડી",
      "noData": "કોઈ ડેટા નથી",
      "mblnumberPlaceHolder": "રિટેલર મોબાઇલ નંબર",
      "name": "નામ",
      "cottn": "કપાસ",
      "corn": "મકાઈ",
      "enterOTP": "OTP નાખો",
      "login": "પ્રવેશ કરો",
      "scanagain": "ફરીથી સ્કેન કરો",
      "Skip": "Skip",
      "Claim": "દાવો",
      "StepsImage": "ડેલિગેટ ડબલ ધમાકા - આ રીત ભાગ લો",
      "sessionExperied": "સત્ર સમાપ્ત થયું. કૃપા કરીને QR કોડ સ્કેન કરો",
      "confirmaccountNumber": "એકાઉન્ટ નંબરની પુષ્ટિ કરો",
      "confirmaccountNumberErrorMsg": "કૃપા કરીને કન્ફર્મ એકાઉન્ટ નંબર દાખલ કરો",
      "confirmAccountNumberMismatch": 'એકાઉન્ટ નંબર કન્ફર્મેશન મેળ ખાતું નથી',
      "UPI": "યુપીઆઈ",
      "invalidOTP": "અમાન્ય OTP",
      "TermsandConditons": "નિયમો અને શરતો",
      "accept": "સ્વીકારો",
      "decline": "નકારો",
      "UPILinkedMobileNumber": "UPI સાથે જોડાયેલ મોબાઇલ નંબર",
      "close": "બંધ કરો",
      "modify": "ફેરફાર કરો"
    },
  },
  ta: {
    "translation": {
      "delegate": "பிரதிநிதி",
      "chilli": "மிளகாய்",
      "language": "tamil",
      "other": "மற்றவை",
      "pleasescan": "தொடர QR குறியீட்டை ஸ்கேன் செய்யவும்",
      "profileText": "*உங்கள் پروஃபைல் 'Corteva Farmer Connect' செயலியில் பதிவு செய்யப்பட்டுள்ளது மற்றும் எதிர்கால சந்தைப்படுத்தல் நடவடிக்கைகளுக்காக உங்களை தொடர்புகொள்ள கோர்ட்டேவாவுக்கு நீங்கள் அங்கீகாரம் அளிக்கிறீர்கள்.",
      "loginLabel": "மொபைல் எண்",
      "loginPlaceHolder": "மொபைல் எண்.",
      "mobileErrorMsg": "மொபைல் எண்ணை உள்ளிடவும்",
      "submitBtn": "சமர்ப்பிக்கவும்",
      "loginBtn": "உள்நுழைக",
      "otpText": "OTP will be sent as an SMS to {mobileNumber}",
      "otpError": "சரியான OTP ஐ உள்ளிடவும்",
      "OTPLabel": "OTP",
      "firstName": "முதல் பெயர்",
      "firstNameErrorMsg": "முதல் பெயரை உள்ளிடவும்",
      "lastName": "கடைசி பெயர்",
      "lastNameErrorMsg": "கடைசி பெயரை உள்ளிடவும்",
      "pincode": "பின்கோடு",
      "address": "முகவரி",
      "done": "முடிந்தது",
      "submit": "சமர்ப்பிக்கவும்",
      "scanTitle": "டெலிகேட் பாட்டிலில் QR குறியீட்டை ஸ்கேன் செய்யவும் ",
      "scanning": "ஸ்கேன் செய்கிறது",
      "scan": "ஸ்கேன் செய்யவும் ",
      "rescan": "மேலும் ஸ்கேன் செய்யவும்",
      "scanSteps": "Steps to scan the QR code",
      "stepOne": "Step 1: Find the QR code on the pouch",
      "stepTwo": "Step 2: Scan the QR code and submit",
      "spinToWin": "பரிசு பெற கிளிக் செய்யவும்",
      "nextStep": "அடுத்த படிக்கு செல்லவும்",
      "scanProduct": "Scan Product",
      "proceedToContinue": "தொடர்ந்து செல்லவும்",
      "SpinWheel": "வெகுமதியைப் பெற சக்கரத்தை சுழற்றுங்கள்",
      "congratulations": "வாழ்த்துக்கள்",
      "giftcongratulations": "வாழ்த்துக்கள், நீங்கள் ஒரு வெற்றியாளர்!",
      "earned": "You have earned Rs. 20.00 cash for Delegate",
      "redeemCash": "பணத்தை மீட்டுக்கொள்ளுங்கள் ",
      "ClaimReward": "வெகுமதியைக் கோருங்கள்",
      "updatesOnReward": "நீங்கள் பிரதிநிதியுடன் வெற்றி பெற்றவர். வெகுமதி பற்றிய அறிவிப்புகளுக்கு உங்கள் உள்ளூர் Corteva பிரதிநிதியைத் தொடர்புகொள்ளவும்",
      "paymentMode": "பணப்பரிமாற்றம் முறையைத் தேர்ந்தெடுக்கவும். ",
      "bankDetails": "வங்கி விவரங்கள்",
      "accountHolderName": "வங்கி கணக்கு பெயர்",
      "accountHolderNameErrorMsg": "கணக்கு வைத்திருப்பவரின் பெயர் தேவை",
      "accountNumber": "வங்கி கணக்கு எண்",
      "accountNumberErrorMsg": "கணக்கு எண்ணை உள்ளிடவும்",
      "IFSCCode": "IFSC குறியீடு.",
      "IFSCCodeErrorMsg": "IFSC குறியீட்டை உள்ளிடவும்",
      "confirm": "உறுதிப்படுத்தவும்.",
      "UPIErrorMsg": "UPI ஐ உள்ளிடவும்.",
      "transferSuccessText": "உங்கள் பணப் பரிமாற்றம் வெற்றிகரமாக உள்ளது. ",
      "successSubtitile": "உங்கள் பணத்தை அனுப்பியுள்ளோம்!",
      "goHome": "முகப்புப் பக்கத்திற்குத் திரும்பு ",
      "delegateRewards": "டெலிகேட் பரிசுகள்",
      "claimList": " உரிமைகோரல் பட்டியல்",
      "noClaimsFound": "உரிமைகோரல்கள் எதுவும் இல்லை",
      "noSuccessList": "வெற்றிப் பட்டியல் எதுவும் இல்லை",
      "reclaimList": "மீட்டெடுப்பு பட்டியல்",
      "noReclaimList": "மீட்டெடுப்பு பட்டியல் எதுவும் இல்லை",
      "termsAndConditions": "பிரதிநிதித்துவ இரட்டை தமாகா - விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "privacyPolicy": "தனியுரிமைக் கொள்கை",
      "agreeText": "சமர்ப்பிப்பதன் மூலம், எங்கள் விதிமுறைகளை ஏற்கிறீர்கள்",
      "genuityCheck": "தயாரிப்பின் உண்மைத்தன்மையைச் சரிபார்த்தல்",
      "resendOTP": "OTP ஐ மீண்டும் அனுப்பவும்",
      "productName": "தயாரிப்பு",
      "serialNO": "வரிசை எண்",
      "alreadyLoginText": "Your number is also logged in to the Farmer Connect app. Press OK to log in.",
      "notRegisteredText": "Your number is not registered. Please register to participate in Delegate Blast.",
      "loginConfirm": "Login Confirmation",
      "Alert": "எச்சரிக்கை!",
      "no": "No",
      "yes": "Yes",
      "OK": "OK",
      "amount": "தொகை",
      "Date": "தேதி",
      "claim": "உரிமைகோரவும்",
      "successList": "வெற்றி பட்டியல்",
      "referenceId": "குறிப்பு ஐடி",
      "status": "நிலை",
      "Scanmore": "மேலும் ஸ்கேன் செய்யவும்",
      "Rewards": "பரிசுகள்",
      "reward": "பரிசுகள்",
      "transfer": "பணப்பரிமாற்றம் ",
      "home": "வீடு",
      "TC": "T&C",
      "ProductInfo": "தயாரிப்பு தகவல்",
      "downloadBrochure": "சிற்றேட்டைப் பதிவிறக்கவும் <br> ",
      "programDetails": "நிரல் விவரங்கள்",
      "delegateParticipate": "Delegate Friendship Blast - Participate",
      "termsAndConditions": "பிரதிநிதித்துவ இரட்டை தமாகா - விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "award": "விருது",
      "TermsandConditons": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "and": "and",
      "privacyPolicy": "தனியுரிமைக் கொள்கை",
      "BackToHome": "முகப்புப் பக்கத்திற்குத் திரும்பு ",
      "ReferenceId": "குறிப்பு ஐடி",
      "noData": "தரவு எதுவும் கிடைக்கவில்லை",
      "mblnumberPlaceHolder": "சில்லறை விற்பனையாளரின் மொபைல் எண்",
      "name": "பெயர்",
      "cottn": "பருத்தி",
      "corn": "சோளம்",
      "enterOTP": "OTP ஐ உள்ளிடவும்",
      "login": "உள்நுழைக",
      "scanagain": "மேலும் ஸ்கேன் செய்யவும்",
      "cropErrorMsg": "தயவு செய்து பயிர் ஒன்றைத் தேர்ந்தெடுக்கவும்",
      "nameErrorMsg": "தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்",
      "Reclaim": "மீட்டெடுக்கவும்",
      "Skip": "Skip",
      "Claim": "உரிமைகோரவும்",
      "StepsImage": "பிரதிநிதித்துவ இரட்டை தமாகா - எப்படி பங்கேற்பது",
      "UPI": "யுபிஐ",
      "bankDetails": "வங்கி விவரங்கள்",
      "confirmaccountNumber": "கணக்கு எண்ணை உறுதிப்படுத்தவும்",
      "confirmaccountNumberErrorMsg": "உறுதிப்படுத்தல் கணக்கு எண்ணை உள்ளிடவும்",
      "confirmAccountNumberMismatch": 'கணக்கு எண் உறுதிப்படுத்தல் பொருந்தவில்லை',
      "sessionExperied": "சத்ர சமாப்த் தாயும். க்ரிபா கரீனே QR கோட் ஸ்கேன் கரோ",
      "invalidOTP": "தவறான OTP",
      "TermsandConditons": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "accept": "സ്വീകരിക്കുക",
      "decline": "നിരസിക്കുക",
      "UPILinkedMobileNumber": "UPI-യുമായി ബന്ധിപ്പിച്ച മൊബൈൽ നമ്പർ",
      "close": "மூடு",
      "modify": "திருத்தவும்"
    }
  },
};

export default resources;
